import { render, staticRenderFns } from "./mesafeli_satis_sozlesmesi.vue?vue&type=template&id=af284e08&"
import script from "./mesafeli_satis_sozlesmesi.vue?vue&type=script&lang=js&"
export * from "./mesafeli_satis_sozlesmesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports